export default __webpack_public_path__ + "static/media/jamuna-1.f4355a4d.PNG";